import { start } from "flavours/glitch/common";

start();
